
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosResponse } from "axios";
import { Overlay } from "@/lib/Overlay";
import moment from "moment";
import { Snackbar } from "@/lib/Snackbar";
import Swal from "sweetalert2";
import VueMask from "v-mask";
import Auth from "@/lib/Auth";
Vue.use(VueMask);
export default Vue.extend({
  name: "IntegracoesHome",

  data() {
    return {
      pinCode: "",
      tipoConta: "PF",
      dialogRemoveTokens: false,
      dialogShowTokens: false,
      dialogRequestTokens: false,
      loadingData: true,
      businessInfo: "",
      btnloading: false,
      dialogTermosApi: false,
      dialogSolicitacaoUso: false,
      requestTokenDomain: "",
      pinCodeRequestToken: "",
      lang: navigator.language,
      ckConfirmCopyTokens: false,
      errors: [] as any,
      ckTermosApi: false,
      moment: moment,
      isMobile: false,
      ModuloInfo: [],
      cadastroInfo: [],
      solicitacaoInfo: [],
      phone: "",
      hasBloqueioTokens: false,
      Tokens: { count: 0, rows: [] },
      newTokens: {
        consulta: "abc",
        transacoes: "def",
      },

      htmlTermosApi:
        "<h3>TERMO DE ADESÃO DISPOSITIVO DE SEGURANÇA - TOKEN</h3>          <h4>I - Partes</h4>          <p>            INTERMEDIADOR: <strong>EZZEBANK SOLUCOES DE PAGAMENTOS EIRELI</strong>, pessoa jurídica de direito privado, com inscrição no CNPJ sob o nº 37.743.906/0001-06, com sede à AE AREA ESPECIAL 4 LOTE I/J TORRE 03, BAIRRO GUARA II, Brasília, DF, CEP 71070-640.          </p>          <p>CLIENTE- pessoa jurídica e/ou equiparada qualificada na Ficha Proposta de Abertura de Conta, por seus legítimos representantes e usuários autorizados.</p>          <p>            Pelo presente instrumento, o INTERMEDIADOR acima identificado, propõe, e o CLIENTE aceita sem qualquer restrição, os seguintes termos e condições:          </p>          <p>            1. O INTERMEDIADOR, visando aumentar a segurança e identificação do CLIENTE no acesso para consulta e transações no âmbito de seu sistema, disponibiliza ao CLIENTE dispositivo denominado 'TOKEN VIRTUAL', que propicia a geração de um código de autenticação de transações realizadas em ambientes seguro VIA API.          </p>          <p>2. O CLIENTE adere sem qualquer ressalva ou restrição aos termos e condições aqui estabelecidos, os quais, doravante, integram e complementam as Condições Gerais do Contrato de Conta Digital Outras Avenças ('Contrato').          </p>          <h4>DO TOKEN VIRTUAL</h4><p>            3. O CLIENTE declara que ao aceitar e utilizar o TOKEN, as transações realizadas em ambiente eletrônico do INTERMEDIADOR deverão necessariamente ter a digitação do código gerado pelo Token, especificamente para a referida transação, em razão do que a transação será considerada inequivocamente realizada pelo CLIENTE, não sendo passível de repúdio. <strong>Para tanto, o CLIENTE está ciente e autoriza que o TOKEN VIRTUAL colete dados do dispositivo necessários para estabelecer o vínculo de autenticação, inclusive do login e transação realizada no ambiente eletrônico, bem como aceita e concorda que os logs de autenticação, acesso e navegação provarão para todos os fins a legitimidade e autenticidade das transações realizadas.</strong>          </p>          <p>4. O CLIENTE declara que o TOKEN VIRTUAL somente deverá ser utilizado para os fins a que se destina, sendo vedado qualquer outro uso fora deste escopo.          </p>          <p>5. O CLIENTE responderá integralmente pelas operações efetuadas mediante uso do TOKEN VIRTUAL, acatando todos os lançamentos correspondentes e assumirá eventuais danos que vier a sofrer em razão do uso indevido do TOKEN VIRTUAL ou por negligência na sua guarda.          </p>          <p>6. O CLIENTE autoriza o INTERMEDIADOR, em caráter irrevogável e irretratável, a debitar todo e qualquer valor relativo as tarifas e responsabilidades previstas no presente Termo, em qualquer conta corrente de sua titularidade, mantida no INTERMEDIADOR.          </p>          <p>Ficam ratificadas todas as demais cláusulas, condições e garantias pactuadas no Contrato, complementadas, no que couber, pelo disposto no presente Termo.          </p>         ",
    };
  },
  created() {
    const dadosUsuario = Auth.getUserData();
    this.tipoConta = dadosUsuario.tipo;

    this.isMobile = this.detectMobile();

    this.moduloInfo();
  },

  methods: {
    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    moduloInfo() {
      Overlay.show();
      Api.get("/v2/client/tokens/getTokensInfo")
        .then((response) => {
          this.ModuloInfo = response.data.body.moduloInfo;
          this.cadastroInfo = response.data.body.cadastroInfo;
          this.solicitacaoInfo = response.data.body.solicitacaoInfo;
          this.Tokens = response.data.body.tokens;
          const rowsTokens = response.data.body.tokens.rows as any;

          rowsTokens.forEach((element: any) => {
            if (element.status != 1) {
              this.hasBloqueioTokens = true;
            }
          });

          // this.ContasDisponivels = response.data.body.bancos;
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status === 404) {
            Snackbar.show(data.body.message, "error");
          }
        })
        .finally(() => {
          this.loadingData = false;
          Overlay.hide();
        });
    },

    SolicitaLiberacao() {
      Overlay.show();

      Api.post("/v2/client/tokens/request_use", {
        businessInfo: this.businessInfo,
        phone: this.phone,
        transactionPin: this.pinCode,
      })
        .then((response) => {
          this.dialogSolicitacaoUso = false;
          Swal.fire({
            text: response.data.body.message,
            icon: "success",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
          this.moduloInfo();
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          Overlay.hide();
        });
    },
    GeraTokens() {
      if (!this.ckTermosApi) {
        Snackbar.show(
          "Marque que está de acordo com os termos de uso",
          "error"
        );
        return false;
      }

      Overlay.show();
      this.btnloading = true;
      this.dialogRequestTokens = false;
      Api.post("/v2/client/tokens/requestNewTokens", {
        dominio: this.requestTokenDomain,
        transactionPin: this.pinCodeRequestToken,
      })
        .then((response) => {
          this.newTokens = response.data.body.tokens;
          this.ckConfirmCopyTokens = false;
          this.dialogShowTokens = true;
          this.pinCodeRequestToken = "";
          this.moduloInfo();
        })
        .catch((error: any) => {
          this.dialogRequestTokens = true;
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          Overlay.hide();
          this.btnloading = false;
        });
    },

    removerTokens() {
      Overlay.show();
      this.btnloading = true;
      this.dialogRemoveTokens = false;
      Api.post("/v2/client/tokens/removeTokens", {
        transactionPin: this.pinCodeRequestToken,
      })
        .then((response) => {
          this.moduloInfo();
          this.pinCodeRequestToken = "";
          Swal.fire({
            text: response.data.body.message,
            icon: "success",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
        })
        .catch((error: any) => {
          this.dialogRemoveTokens = true;
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          Swal.fire({
            text: data.body.error,
            icon: "error",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
        })
        .finally(() => {
          Overlay.hide();
          this.btnloading = false;
        });
    },
    cancelaRequestTokens() {
      this.ckTermosApi = false;
      this.dialogRequestTokens = false;
    },
  },
});
